import { nextApiRoutesClient } from 'modules/common/http/nextApiRoutesClient'

export const postRevokeRefreshToken = async () => {
  const { data } = await nextApiRoutesClient.post<void>(
    '/api/auth/revokeRefreshToken'
  )

  return data
}
